import { CALL_API } from '../../../middleware/api';
import { apiEndpoints } from '../../../services/ApiEndpointsConstants';
import * as authConstants from '../../../services/ApiEndpointsConstants';
import * as Auth from './AuthConstants';

export function loginUser(requestParams) {
  return {
    [CALL_API]: {
      config: {
        data: requestParams,
        method: 'post'
      },
      endpoint: apiEndpoints().entity(authConstants.LOGIN_USER),
      types: [Auth.LOGIN_REQUEST, Auth.LOGIN_SUCCESS, Auth.LOGIN_FAILED]
    }
  };
}

// export function logOutUser() {
//   return {
//     [CALL_API]: {
//       endpoint: apiEndpoints().entity(authConstants.LOGOUT_USER),
//       types: [
//         Auth.LOGOUT_REQUEST,
//         Auth.LOGOUT_SUCCESS,
//         Auth.LOGOUT_FAILED,
//       ],
//     },
//   }
// }

export function getUserInfo() {
  return {
    [CALL_API]: {
      endpoint: apiEndpoints().entity(authConstants.GET_USER_INFO),
      types: [
        Auth.GET_USER_INFO_REQUEST,
        Auth.GET_USER_INFO_SUCCESS,
        Auth.GET_USER_INFO_FAILED
      ]
    }
  };
}

export function clearLoginError() {
  return {
    type: Auth.LOGIN_CLEAR
  };
}

export function logOutUser() {
  return {
    type: Auth.TOKEN_CLEAR
  };
}
